import React from "react";
import { SelectOption } from "@showitinc/showit-wc";

import Input from "../../../base/Input";
import { SELECT } from "../../../../constants/InputConstants.mjs";
import AppConstants from "../../../../constants/AppConstants";
import TextTags, { TAG_DIV } from "../../../../constants/TextTags";
import { initFormatter } from "../../../../utils/PropertyFormatters";
import { prepareInputUtils } from "../../../../utils/InputUtils";
import { isValueMixed } from "../../../../utils/InheritanceUtils";
import { MIXED } from "../../../../constants/DesignConstants.mjs";

const TextAdvancedProperties = ({ isLocked, onPropUpdate, element, preparedElement, theme }) => {
  const { prepareValue } = prepareInputUtils(undefined, preparedElement);
  const style = prepareValue("style");

  // this is the usecase for top level style. We can decide to not look at this when we default to div
  const defaultTag = theme.getIn(["styles", style, "tag"], TAG_DIV);
  const elementTag = prepareValue("tag", isValueMixed(style) ? MIXED : defaultTag);

  const _onPropChange = (propInfo) => {
    onPropUpdate({
      ...propInfo,
      value: propInfo?.value === defaultTag ? null : propInfo?.value,
    });
  };

  const { onChange } = initFormatter(_onPropChange);

  // If custom tag is disabled (e.g. bulleted/numbered list), prevent adding an additional tag
  const customTagDisabled = element.get(AppConstants.CUSTOM_TAG_DISABLED) === 1;
  const tag = elementTag;

  return (
    <Input
      disabled={customTagDisabled || isLocked}
      inputType={SELECT}
      label="Text Tag"
      // helpTooltip={`text-properties-text-tag${customTagDisabled ? "-custom" : ""}`}
      onSISelect={onChange("tag", tag)}
      reserveContext
      shift="left"
      value={tag}
    >
      {TextTags.map((elemTag) => (
        <SelectOption key={`tag-${elemTag}`} value={elemTag}>
          {elemTag}
        </SelectOption>
      ))}
    </Input>
  );
};

export default TextAdvancedProperties;
